export default {
  'components.avatarDropdown.center': '个人中心',
  'components.avatarDropdown.settings': '个人设置',
  'components.avatarDropdown.logout': '退出登录',
  'components.avatarDropdown.logoutSuccess': '退出登录成功',

  'components.siderFooter.notLoggedIn': '未登录',
  'components.siderFooter.login': '登录',
  'components.siderFooter.logout': '退出登录',
  'components.siderFooter.logoutSuccess': '退出登录成功',
  'components.siderFooter.subscriptionAndRecharge': '订阅与充值',
  'components.siderFooter.subscribeRecharge': '订阅/充值',
  'components.siderFooter.credits': '积分余额',
  'components.siderFooter.inviteLink': '邀请链接',
  'components.siderFooter.inviteLinkCopied': '邀请链接已复制到剪贴板',
  'components.siderFooter.copyFailed': '复制失败，请手动复制',
  'components.siderFooter.getInviteLinkFailed': '获取邀请链接失败',
  'components.siderFooter.inviteModal.title': '邀请链接',
  'components.siderFooter.inviteModal.description': '分享以下链接邀请好友注册：',
  'components.siderFooter.personalAccount': '个人账户',
  'components.siderFooter.loginPromptTitle': '登录后获得更完整的对话体验',
  'components.siderFooter.loginPromptDesc': '同步历史会话、并使用模板制作专业视频',
  'components.siderFooter.preferences': '偏好设置',
  'components.siderFooter.language': '语言',
  'components.siderFooter.recharge': '充值',
  'components.siderFooter.upgrade': '升级',
  'components.siderFooter.transactionHistory': '交易管理',
  'components.siderFooter.freePlan': '免费版',
  'components.siderFooter.balanceValue': '{amount}',
  'components.siderFooter.copy': '复制',
  'common.updating': '更新中',

  'components.paymentModal.title': '订阅与充值',
  'components.paymentModal.tab.plans': '订阅',
  'components.paymentModal.tab.recharge': '充值',
  'components.paymentModal.checkoutTitle': '确认支付',
  'components.paymentModal.back': '返回',
  'components.paymentModal.close': '关闭',

  'components.loginModal.captchaError': '验证码错误',
  'components.loginModal.loginSuccess': '登录成功！',
  'components.loginModal.loginFailed': '登录失败，请重试！',
  'components.loginModal.googleAccessTokenMissing': '未获取到 Google 授权令牌',
  'components.loginModal.googleBlocked': 'Google 登录组件加载中或被屏蔽，请检查网络',
  'components.loginModal.fetchQrcodeFailed': '获取二维码失败，请重试',
  'components.loginModal.registerSuccess': '注册成功！',
  'components.loginModal.registerFailed': '注册失败，请重试',
  'components.loginModal.scanDisconnected': '扫码连接中断，请重试',
  'components.loginModal.refreshQrcodeFailed': '刷新二维码失败',
  'components.loginModal.wechatScanLogin': '微信扫码登录',
  'components.loginModal.wechatQrcodeAlt': '微信二维码',
  'components.loginModal.loggingIn': '登录中...',
  'components.loginModal.registering': '注册中...',
  'components.loginModal.refreshQrcode': '刷新二维码',
  'components.loginModal.clickRefresh': '点击刷新',
  'components.loginModal.wechatScanHint': '打开微信扫一扫授权登录',
  'components.loginModal.wechatRegisterTitle': '扫码注册',
  'components.loginModal.wechatRegisterSubtitle': '请使用微信扫描二维码完成注册',
  'components.loginModal.wechatRegisterHint': '打开微信扫一扫\n扫码后自动完成注册',
  'components.loginModal.back': '返回',
  'components.loginModal.wechatLoginHintTitle': '扫码登录',
  'components.loginModal.wechatLoginHintSubtitle': '请使用微信扫描左侧二维码登录',
  'components.loginModal.wechatLoginHintDescription': '扫码成功后将自动登录',
  'components.loginModal.backToAccountLogin': '返回账号登录',
  'components.loginModal.tabs.login': '登录',
  'components.loginModal.tabs.register': '注册',
  'pages.login.thirdPartyLogin': '其他登录方式',
  'components.loginModal.loginForm.clientAccountRequired': '请输入企业账号',
  'components.loginModal.loginForm.clientAccountPlaceholder': '企业账号',
  'components.loginModal.loginForm.usernameRequired': '请输入用户名',
  'components.loginModal.loginForm.usernamePlaceholder': '用户名',
  'components.loginModal.loginForm.passwordRequired': '请输入密码',
  'components.loginModal.loginForm.passwordPlaceholder': '密码',
  'components.loginModal.loginForm.captchaRequired': '请输入计算结果',
  'components.loginModal.loginForm.captchaPlaceholder': '计算结果',
  'components.loginModal.clickRefreshShort': '点击刷新',
  'components.loginModal.login': '登录',
  'components.loginModal.registerForm.clientAccountRequired': '请输入个人用户帐号',
  'components.loginModal.registerForm.clientAccountPlaceholder': '个人用户帐号',
  'components.loginModal.register': '注册',
  'components.loginModal.thirdPartyLogin': '其他登录方式',
  'components.loginModal.googleProcessing': 'Google 登录处理中',
  'components.loginModal.googleLogin': 'Google 登录',
  'components.loginModal.wechatLogin': '微信登录',
  'components.loginModal.googleAuthProcessing': '正在处理 Google 授权，请稍候...',

  'pages.payment.plans.title': '选择订阅计划',
  'pages.payment.plans.pageSubtitle': '比较不同套餐权益，选择最适合当前使用节奏的订阅方案。',
  'pages.payment.plans.loadFailed': '订阅计划加载失败',
  'pages.payment.plans.loadFailedDesc': '请稍后刷新重试，或联系管理员检查支付套餐配置。',
  'pages.payment.plans.empty': '当前暂无可用订阅计划，请联系管理员配置后再试',
  'pages.payment.plans.emptyGroup': '当前暂无{group}套餐',
  'pages.payment.plans.selected': '已选中',
  'pages.payment.plans.currentSubscription': '当前订阅',
  'pages.payment.plans.free': '免费',
  'pages.payment.plans.billingCycle.month': '月',
  'pages.payment.plans.billingCycle.year': '年',
  'pages.payment.plans.billingCycle.twoWeek': '两周',
  'pages.payment.plans.billingCycle.quarter': '季',
  'pages.payment.plans.billingCycle.generic': '周期',
  'pages.payment.plans.billingTab.month': '月付',
  'pages.payment.plans.billingTab.year': '年付',
  'pages.payment.plans.billingTab.twoWeek': '特惠',
  'pages.payment.plans.billingTab.specialOffer': '限时特惠',
  'pages.payment.plans.billingTab.quarter': '季付',
  'pages.payment.plans.billingTab.generic': '套餐',
  'pages.payment.plans.rollover.full': '额度可全部结转',
  'pages.payment.plans.rollover.ratio': '可结转 {ratio}% 额度',
  'pages.payment.plans.rollover.none': '额度不结转',
  'pages.payment.plans.subtitle.free': '适合初次体验',
  'pages.payment.plans.subtitle.specialOffer': '适合短期试用与快速上手',
  'pages.payment.plans.subtitle.basic': '适合轻量日常使用',
  'pages.payment.plans.subtitle.standard': '适合稳定高频使用',
  'pages.payment.plans.subtitle.enterprise': '适合团队与更高配额场景',
  'pages.payment.plans.subtitle.default': '按当前使用规模选择',
  'pages.payment.plans.badge.twoWeek': '限时体验',
  'pages.payment.plans.badge.year': '长期使用更划算',
  'pages.payment.plans.feature.credits': '包含 {credits} 点数',
  'pages.payment.plans.feature.duration': '有效期 {days} 天',
  'pages.payment.plans.purchaseLimit': '每人限购 {count} 次',
  'pages.payment.plans.cta.tryNow': '立即体验',
  'pages.payment.plans.cta.subscribeNow': '立即订阅',
  'pages.payment.plans.cta.subscribed': '已订阅其他套餐',
  'pages.payment.plans.sticky.selected': '已选择「{name}」',
  'pages.payment.plans.sticky.duration': '有效期 {days} 天',
  'pages.payment.plans.sticky.meta': '{price}，包含 {credits} 点数',
  'pages.payment.plans.summary.active': '当前有效订阅',
  'pages.payment.plans.summary.currentPlan': '当前套餐',
  'pages.payment.plans.summary.remaining': '剩余 {days} 天',
  'pages.payment.plans.summary.validUntil': '有效订阅至 {date}{remaining}',
  'pages.payment.plans.summary.permanent': '永久有效',

  'pages.payment.recharge.title': '充值点数',
  'pages.payment.recharge.subtitle': '充值后点数永久有效',
  'pages.payment.recharge.methodsLoadFailed': '获取支付方式失败',
  'pages.payment.recharge.needSubscriptionFirst': '充值前需要先订阅非免费套餐',
  'pages.payment.recharge.amountRequired': '请输入充值金额',
  'pages.payment.recharge.amountInteger': '充值金额必须为大于 0 的整数',
  'pages.payment.recharge.disabledTitle': '充值已禁用',
  'pages.payment.recharge.disabledDesc': '请先订阅非免费套餐后再充值。',
  'pages.payment.recharge.paymentMethod': '支付方式',
  'pages.payment.recharge.amountLabel': '充值金额 ({currency})',
  'pages.payment.recharge.amountPlaceholder': '请输入充值金额',
  'pages.payment.recharge.baseCredits': '基础点数',
  'pages.payment.recharge.bonusCredits': '赠送点数',
  'pages.payment.recharge.totalCredits': '到账总点数',
  'pages.payment.recharge.goPay': '去支付',

  'pages.payment.checkout.methodsLoadFailed': '获取支付方式失败',
  'pages.payment.checkout.createOrderFailed': '创建订单失败',
  'pages.payment.checkout.networkInterrupted': '网络连接中断，请刷新页面或检查支付结果',
  'pages.payment.checkout.title': '确认支付',
  'pages.payment.checkout.pageSubtitle': '确认订单信息与支付方式，完成当前订阅或充值。',
  'pages.payment.checkout.orderType': '订单类型',
  'pages.payment.common.days': '天',
  'pages.payment.checkout.subscription': '订阅',
  'pages.payment.checkout.recharge': '充值',
  'pages.payment.checkout.plan': '套餐',
  'pages.payment.checkout.duration': '有效期',
  'pages.payment.checkout.amount': '金额',
  'pages.payment.checkout.totalCredits': '到账总点数',
  'pages.payment.checkout.creditsUnit': '点',
  'pages.payment.checkout.settlementAmount': '结算金额 {amount}',
  'pages.payment.checkout.benefits.subscription': '订阅权益按套餐配置发放',
  'pages.payment.checkout.benefits.recharge': '到账点数按结算金额计算',
  'pages.payment.checkout.equivalentCny': '等值 ¥{amount}，积分按此金额计算',
  'pages.payment.checkout.paymentMethod': '支付方式',
  'pages.payment.checkout.selectPaymentMethod': '选择支付方式',
  'pages.payment.checkout.confirmPay': '确认支付',
  'pages.payment.checkout.scanWechatPay': '请使用微信扫码支付',
  'pages.payment.checkout.waitingPay': '等待支付中...',
  'pages.payment.checkout.orderExpires': '订单将于 30 分钟后过期',
  'pages.payment.checkout.paySuccess': '支付成功',
  'pages.payment.checkout.payFailed': '支付失败',
  'pages.payment.checkout.payCancelled': '已取消支付',
  'pages.payment.checkout.orderNo': '订单号: {orderNo}',
  'pages.payment.checkout.close': '关闭',
  'pages.payment.checkout.paypalOpened': '已打开 PayPal（新窗口）',
  'pages.payment.checkout.paypalOpenedDesc': '请在 PayPal 完成支付，本窗口会自动刷新支付结果。',
  'pages.payment.checkout.paypalReopen': '重新打开 PayPal',
  'pages.payment.checkout.capturing': '正在确认支付...',
  'pages.payment.checkout.capturingDesc': '请稍候，正在处理 PayPal 支付结果',
  'pages.payment.checkout.capturingPaypal': '正在确认 PayPal 支付...',
  'pages.payment.checkout.autoClose': '此窗口将自动关闭',
  'pages.payment.checkout.closeWindow': '关闭窗口',

  'pages.payment.result.pageTitle': '支付结果',
  'pages.payment.result.pageSubtitle': '查看订单状态并继续下一步操作。',
  'pages.payment.result.success': '支付成功',
  'pages.payment.result.cancelled': '支付已取消',
  'pages.payment.result.failed': '支付失败',
  'pages.payment.result.backHome': '返回首页',
  'pages.payment.result.viewPlans': '查看计划',
  'pages.payment.result.orderType': '订单类型',
  'pages.payment.result.amount': '金额',
  'pages.payment.result.status': '状态',
  'pages.payment.result.paidTime': '支付时间',
  'pages.payment.result.subscription': '订阅',
  'pages.payment.result.recharge': '充值',
  'pages.payment.result.orderNo': '订单号: {orderNo}',

  'pages.payment.invite.title': '邀请记录',
  'pages.payment.invite.summary.invitees': '已邀请用户',
  'pages.payment.invite.summary.rewards': '累计奖励点数',
  'pages.payment.invite.col.invitee': '受邀用户ID',
  'pages.payment.invite.col.clientId': '客户端ID',
  'pages.payment.invite.col.rewardCount': '奖励次数',
  'pages.payment.invite.col.totalReward': '累计奖励',
  'pages.payment.invite.col.registerTime': '注册时间',
  'pages.payment.invite.reward.eventType': '事件类型',
  'pages.payment.invite.reward.amount': '奖励点数',
  'pages.payment.invite.reward.time': '时间',
  'pages.payment.invite.noRewards': '暂无奖励记录',
  'pages.payment.invite.empty': '暂无邀请记录',
  'pages.payment.invite.total': '共 {total} 位受邀用户',

  'pages.payment.orders.title': '交易管理',
  'pages.payment.orders.col.orderNo': '订单号',
  'pages.payment.orders.col.orderType': '类型',
  'pages.payment.orders.col.paymentMethod': '支付方式',
  'pages.payment.orders.col.amount': '金额',
  'pages.payment.orders.col.status': '状态',
  'pages.payment.orders.col.businessId': '业务ID',
  'pages.payment.orders.col.paidTime': '支付时间',
  'pages.payment.orders.col.createTime': '创建时间',
  'pages.payment.orders.search': '搜索订单号',
  'pages.payment.orders.statusFilter': '按状态筛选',
  'pages.payment.orders.total': '共 {total} 条订单',
  'pages.payment.orders.empty': '暂无交易记录',
  'pages.payment.orders.status.INIT': '待支付',
  'pages.payment.orders.status.PAID': '已支付',
  'pages.payment.orders.status.DONE': '已完成',
  'pages.payment.orders.status.CANCELLED': '已取消',
  'pages.payment.orders.status.EXPIRED': '已过期',
  'pages.payment.orders.status.FAILED': '失败',
  'pages.payment.orders.type.SUBSCRIPTION': '订阅',
  'pages.payment.orders.type.RECHARGE': '充值',
  'pages.payment.orders.method.WECHAT_NATIVE': '微信支付',
  'pages.payment.orders.method.PAYPAL': 'PayPal',
  'pages.payment.orders.method.STRIPE': 'Stripe',
  'pages.payment.orders.method.ALIPAY': '支付宝',
  'pages.payment.orders.method.BALANCE': '余额支付',

  'pages.about.hero.title': 'AI 短视频创作平台',
  'pages.about.hero.copy':
    '问途DOSSM 是一个面向酒店、餐饮、旅游业商用级短视频创作AI原生应用平台。<br> 我们致力于专业场景下高质量商业宣传短视频创意与生产，为业内广大内容营销创意工作者提供专业、可靠、高效的AI内容创作工具，引领行业创意内容营销新范式',
  'pages.about.intro.enableSound': '开启声音',
  'pages.about.intro.mutePlayback': '静音播放',
  'pages.about.intro.skip': '跳过欢迎片',
  'pages.about.video.title': 'DOSSM 产品介绍视频',
  'pages.about.contact.title': '联系我们',
  'pages.about.contact.business': '商务合作',
  'pages.about.contact.phone': '联系电话',
  'pages.about.contact.address': '公司地址',
  'pages.about.contact.addressValue': '广州天河区科韵路12-1号 方圆E时光1202',
  'pages.about.contact.qrAlt': '官方客服二维码',
  'pages.about.contact.qrTitle': '专属1v1服务',

  'pages.workspace.justNow': '刚刚',
  'pages.workspace.minutesAgo': '{count}分钟前',
  'pages.workspace.hoursAgo': '{count}小时前',
  'pages.workspace.yesterday': '昨天',
  'pages.workspace.daysAgo': '{count}天前',
  'pages.workspace.untitledSession': '未命名会话',
  'pages.workspace.unpinSuccess': '已取消置顶',
  'pages.workspace.pinSuccess': '已置顶',
  'pages.workspace.deleted': '已删除',
  'pages.workspace.titleColumn': '标题',
  'pages.workspace.agentNameColumn': '智能体名称',
  'pages.workspace.updatedColumn': '更新',
  'pages.workspace.unpin': '取消置顶',
  'pages.workspace.pin': '置顶',
  'pages.workspace.deleteConfirm': '确定删除这条记录吗？',
  'pages.workspace.confirm': '确定',
  'pages.workspace.cancel': '取消',
  'pages.workspace.pageTitle': '我的工作',
  'pages.workspace.search': '搜索',
  'pages.workspace.status.running': '执行中',
  'pages.workspace.status.waiting': '等待你的输入',
  'pages.workspace.status.disposed': '已终止',
  'pages.workspace.status.readOnly': '仅查看',
  'pages.workspace.status.static': '已完成',
  'pages.workspace.pageSubtitle': '集中查看会话任务状态，并从统一列表继续你的工作。',
  'pages.workspace.recordsTitle': '会话记录',
  'pages.workspace.emptyDescription': '当前还没有工作记录。新建会话后会在这里展示。',
  'pages.workspace.emptySearchDescription': '没有匹配当前搜索关键词的会话。',
  'pages.workspace.metric.total': '会话总数',
  'pages.workspace.metric.running': '执行中',
  'pages.workspace.metric.waiting': '等待输入',
  'pages.workspace.metric.pinned': '已置顶',
  'pages.workspace.loadFailed': '加载工作记录失败，请检查网络后重试。',
  'pages.workspace.loadFailedToast': '刷新工作记录失败，请稍后重试。',
  'pages.workspace.retry': '重试',

  'pages.welcome.badge.new': '新',
  'pages.welcome.use': '使用',
  'pages.welcome.bestPractices': '最佳实践',
  'pages.welcome.more': '更多',
  'pages.welcome.noBestPractices': '暂无最佳实践',
  'pages.welcome.heroPlaceholder': '描述一下你的想法',
  'pages.welcome.heroShortcut': '帮我写段朋友圈文案',
  'pages.welcome.myAgents': '我的智能体',
  'pages.welcome.agentSpace': '智能体空间',
  'pages.welcome.noDescription': '暂无描述',
  'pages.welcome.lastModified': '最近修改：',
  'pages.welcome.lastViewed': '最近查看：',
  'pages.welcome.copy': '复制',
  'pages.welcome.pin': '置顶',
  'pages.welcome.unpin': '取消置顶',
  'pages.welcome.deleteConfirm': '确定删除这个智能体吗？',
  'pages.welcome.confirm': '确定',
  'pages.welcome.cancel': '取消',
  'pages.welcome.noAgents': '暂无智能体',
  'pages.welcome.noPublicAgents': '暂无公开智能体',
  'pages.welcome.allBestPractices': '全部最佳实践',
  'pages.welcome.allAgents': '全部智能体',
  'pages.welcome.deleteSuccess': '删除成功',
  'pages.welcome.deleteFailed': '删除失败',
  'pages.welcome.copySuccess': '复制成功',
  'pages.welcome.copyFailed': '复制失败',
  'pages.welcome.pinSuccess': '已置顶',
  'pages.welcome.unpinSuccess': '已取消置顶',
  'pages.welcome.firstVisit.badge': '欢迎使用',
  'pages.welcome.firstVisit.title': '欢迎来到 Hospitality AI Video Platform',
  'pages.welcome.firstVisit.description': '你可以从一个想法开始，也可以先浏览最佳实践和智能体空间，快速进入旅游与酒店内容创作流程。',
  'pages.welcome.firstVisit.feature.workspace.title': '从一个想法开始',
  'pages.welcome.firstVisit.feature.workspace.desc': '输入你的需求，快速发起新会话，并在统一工作流里持续推进。',
  'pages.welcome.firstVisit.feature.agents.title': '浏览最佳实践与智能体',
  'pages.welcome.firstVisit.feature.agents.desc': '先看看平台已有案例和智能体，能更快找到适合当前任务的起点。',
  'pages.welcome.firstVisit.feature.video.title': '面向文旅场景的视频创作',
  'pages.welcome.firstVisit.feature.video.desc': '围绕旅游与酒店管理内容，逐步组织脚本、素材和 AI 视频生产流程。',
  'pages.welcome.firstVisit.hint': '该欢迎弹窗仅在当前浏览器首次访问首页时展示一次。',
  'pages.welcome.firstVisit.later': '关闭',
  'pages.welcome.firstVisit.start': '确定',

  'pages.agents.pageTitle': '我的智能体',
  'pages.agents.configuredAgents': '已配置的 Agent ({count})',
  'pages.agents.noDescription': '暂无描述',
  'pages.agents.empty': '暂无智能体',
  'pages.agents.add': '新增',
  'pages.agents.addAgent': '新增智能体',
  'pages.agents.addToolAgent': '新增工具智能体',
  'pages.agents.save': '保存',
  'pages.agents.delete': '删除',
  'pages.agents.startWork': '开始工作',
  'pages.agents.toolAgentHint': '[工具智能体]',
  'pages.agents.selectOne': '请选择一个智能体',
  'pages.agents.deleteConfirm': '确定删除这个智能体吗？所有相关工作数据和记录都会同时删除！',
  'pages.agents.setToolName': '设置智能体工具名称',
  'pages.agents.setToolNameDesc': '该名称将作为工具被其他智能体调用时使用',
  'pages.agents.toolNamePlaceholder': '请输入工具名称（英文）',
  'pages.agents.enterToolName': '请输入工具名称',
  'pages.agents.fillRequiredFields': '请填写必填项',
  'pages.agents.addSuccess': '新增成功',
  'pages.agents.saveSuccess': '保存成功',
  'pages.agents.deleteSuccess': '删除成功',
  'pages.agents.pinSuccess': '已置顶',
  'pages.agents.unpinSuccess': '已取消置顶',
  'pages.agents.selectType': '选择智能体类型',
  'pages.agents.type.normal': '普通智能体',
  'pages.agents.type.normalDesc': '通用型智能体，可以使用多种工具完成复杂任务',
  'pages.agents.type.tool': '工具子智能体',
  'pages.agents.type.toolDesc': '作为工具被其他智能体调用的专用智能体',
  'pages.agents.pageSubtitle': '维护智能体资产、编辑能力配置，并从统一工作区发起工作。',
  'pages.agents.configuredAgentsHint': '选择一个智能体以查看或编辑其配置。',
  'pages.agents.loadFailed': '加载智能体列表失败，请检查网络后重试。',
  'pages.agents.loadFailedToast': '刷新智能体列表失败，请稍后重试。',
  'pages.agents.detailLoadFailed': '加载智能体详情失败，请稍后重试。',
  'pages.agents.detailLoadFailedToast': '刷新智能体详情失败，请稍后重试。',
  'pages.agents.retry': '重试',

  'components.agentSettingsForm.title': 'Agent 名称',
  'components.agentSettingsForm.titleRequired': '请输入Agent名称',
  'components.agentSettingsForm.titlePlaceholder': '请输入Agent名称',
  'components.agentSettingsForm.displayName': '显示名称',
  'components.agentSettingsForm.displayNamePlaceholder': '请输入显示名称',
  'components.agentSettingsForm.description': '描述',
  'components.agentSettingsForm.descriptionRequired': '请输入描述',
  'components.agentSettingsForm.descriptionPlaceholder': '请输入描述',
  'components.agentSettingsForm.model': '推理模型',
  'components.agentSettingsForm.modelRequired': '请选择推理模型',
  'components.agentSettingsForm.modelPlaceholder': '请选择推理模型',
  'components.agentSettingsForm.callLimit': '最大执行次数',
  'components.agentSettingsForm.callLimitRequired': '请输入最大执行次数',
  'components.agentSettingsForm.callLimitInvalid': '请输入1-100之间的数字',
  'components.agentSettingsForm.callLimitPlaceholder': '请输入最大执行次数',
  'components.agentSettingsForm.shareContext': '是否共享上下文',
  'components.agentSettingsForm.shareContextRequired': '请选择是否共享上下文',
  'components.agentSettingsForm.yes': '是',
  'components.agentSettingsForm.no': '否',
  'components.agentSettingsForm.systemPrompt': 'Agent提示词',
  'components.agentSettingsForm.systemPromptRequired': '请输入Agent提示词',
  'components.agentSettingsForm.maximize': '最大化',
  'components.agentSettingsForm.toolParams': '工具参数定义',
  'components.agentSettingsForm.jsonValid': 'JSON 有效',
  'components.agentSettingsForm.jsonInvalid': 'JSON 无效',
  'components.agentSettingsForm.empty': '空',
  'components.agentSettingsForm.toolParamsRequired': '请输入工具参数定义',
  'components.agentSettingsForm.toolParamsPlaceholder': '请输入工具参数数组，例如：包含 name、type、description、required 字段的 JSON 数组',
  'components.agentSettingsForm.toolPromptTemplate': '工具提示词模板',
  'components.agentSettingsForm.toolPromptTemplateRequired': '请输入工具提示词模板',
  'components.agentSettingsForm.jsonFormatInvalid': 'JSON 格式无效',
  'components.agentSettingsForm.autoApprove': '自动授权',
  'components.agentSettingsForm.manualApprove': '手动授权',
  'components.agentSettingsForm.tab.mySkills': '我的技能 ({selected}/{total})',
  'components.agentSettingsForm.tab.builtInSkills': '内置技能 ({selected}/{total})',
  'components.agentSettingsForm.tab.builtInTools': '内置工具 ({selected}/{total})',
  'components.agentSettingsForm.tab.subAgentTools': '子智能体工具 ({selected}/{total})',
  'components.agentSettingsForm.modal.role': '角色 / 人设定义',
  'components.agentSettingsForm.modal.ability': '能力定义',
  'components.agentSettingsForm.modal.plan': '任务指导',
  'components.agentSettingsForm.modal.toolParams': '工具参数定义',
  'components.agentSettingsForm.modal.toolPrompt': '工具提示词模板',
  'components.agentSettingsForm.confirm': '确定',
  'components.agentSettingsForm.cancel': '取消',
  'components.agentSettingsForm.schema.name': '参数名称',
  'components.agentSettingsForm.schema.type': '参数类型（如 string, int, number, boolean, array 等）',
  'components.agentSettingsForm.schema.description': '参数描述',
  'components.agentSettingsForm.schema.required': '是否必填（默认 true）',

  'components.jsonEditor.placeholder': '请输入JSON...',
  'components.jsonEditor.mustBeArray': '数据必须是数组类型',
  'components.jsonEditor.arrayItemError': '数组第 {index} 项: {error}',
  'components.jsonEditor.mustBeObject': '必须是对象类型',
  'components.jsonEditor.requiredFieldMissing': '缺少必填字段 "{field}"',
  'components.jsonEditor.typeMismatch': '字段 "{field}" 类型错误，期望 {expected}，实际 {actual}',
  'components.jsonEditor.schemaValidationFailed': 'Schema 验证失败',
  'components.jsonEditor.format': '格式化',
  'components.jsonEditor.jsonValid': 'JSON 有效',
  'components.jsonEditor.jsonInvalid': 'JSON 无效',
  'components.jsonEditor.empty': '空',

  'components.toolCardList.empty': '暂无可选工具',
  'components.toolCardList.costTooltip': '工具消耗点数成本的程度（0至5）',

  'pages.skills.file.apiDocs': '工具调用参数',
  'pages.skills.file.examples': '使用示例',
  'pages.skills.file.promptGuide': 'Prompt 撰写指南',
  'pages.skills.pageTitle': '我的技能',
  'pages.skills.pageSubTitle': '把高频流程沉淀成技能包，随时复用。',
  'pages.skills.configuredCount': '已配置的 Skill ({count})',
  'pages.skills.configuredHint': '选择一个技能查看或编辑其内容。',
  'pages.skills.add': '新增',
  'pages.skills.unnamed': '未命名技能',
  'pages.skills.noDescription': '暂无描述',
  'pages.skills.disabled': '已停用',
  'pages.skills.enabled': '启用中',
  'pages.skills.empty': '暂无技能',
  'pages.skills.addSkill': '新增技能',
  'pages.skills.detail': '技能详情',
  'pages.skills.copy': '复制',
  'pages.skills.delete': '删除',
  'pages.skills.save': '保存',
  'pages.skills.deleteConfirm': '确定删除这个技能吗？',
  'pages.skills.selectOne': '请选择一个技能',
  'pages.skills.retry': '重试',
  'pages.skills.detailLoadFailed': '加载技能详情失败，请稍后重试。',
  'pages.skills.addSuccess': '新增成功',
  'pages.skills.saveSuccess': '保存成功',
  'pages.skills.deleteSuccess': '删除成功',
  'pages.skills.deleteFailed': '删除失败',
  'pages.skills.copySuccess': '复制成功',
  'pages.skills.fillRequiredFields': '请填写必填项',
  'pages.skills.generateNameNeedTitle': '请输入标题后再生成',
  'pages.skills.field.title': '技能标题（title）',
  'pages.skills.field.titleRequired': '请输入技能标题',
  'pages.skills.field.titleExtra': '展示给用户的标题',
  'pages.skills.field.titlePlaceholder': '例如：订单管理',
  'pages.skills.field.name': '技能标识（name）',
  'pages.skills.field.nameExtraCreate': '建议使用英文小写与短横线；保存时服务端可能自动加前缀确保唯一',
  'pages.skills.field.nameExtraEdit': '用于引用与调用，建议不要修改',
  'pages.skills.field.nameRequired': '请输入技能标识',
  'pages.skills.field.description': '技能描述',
  'pages.skills.field.descriptionRequired': '请输入技能描述',
  'pages.skills.field.descriptionPlaceholder': '一句话说明这个技能解决什么问题',
  'pages.skills.field.content': '技能内容（SKILL.md）',
  'pages.skills.field.contentRequired': '请输入技能内容',
  'pages.skills.modal.content': '技能内容（SKILL.md）',
  'pages.skills.attachment.deleteConfirm': '确定删除该附件吗？',
  'pages.skills.attachment.add': '添加',
  'pages.skills.attachment.delete': '删除',
  'pages.skills.attachment.edit': '编辑',
  'pages.skills.attachment.create': '创建',
  'pages.skills.attachment.empty': '尚未配置',
  'pages.skills.attachment.hint': '附件内容会随 Skill 保存，并覆盖服务端对应文件。',
  'pages.skills.attachment.editModal': '编辑附件',
  'pages.skills.attachment.ready': '内容已配置，可随时继续编辑',
  'pages.skills.attachment.configured': '已配置',
  'pages.skills.attachment.unconfigured': '未配置',
  'pages.skills.tab.attachments': '技能附件 ({configured}/{total})',
  'pages.skills.tab.tools': '内置工具 ({selected}/{total})',
  'pages.skills.tab.toolsPlain': '工具',

  'pages.knowledge.pageTitle': '资料库',
  'pages.knowledge.pageSubtitle': '统一管理知识资产，并维护文档召回配置。',
  'pages.knowledge.configuredCount': '已配置的资料库 ({count})',
  'pages.knowledge.configuredHint': '选择一个资料库查看文档或调整配置。',
  'pages.knowledge.add': '新增',
  'pages.knowledge.unnamed': '未命名',
  'pages.knowledge.noDescription': '暂无描述',
  'pages.knowledge.empty': '暂无资料库',
  'pages.knowledge.selectOne': '请选择一个资料库',
  'pages.knowledge.files': '文件',
  'pages.knowledge.addFile': '添加文件',
  'pages.knowledge.emptyFiles': '暂无文件',
  'pages.knowledge.table.name': '名称',
  'pages.knowledge.table.uploadTime': '上传时间',
  'pages.knowledge.table.status': '状态',
  'pages.knowledge.table.action': '操作',
  'pages.knowledge.menu.edit': '编辑',
  'pages.knowledge.menu.delete': '删除',
  'pages.knowledge.menu.rename': '重命名',
  'pages.knowledge.menu.download': '下载',
  'pages.knowledge.modal.deleteTitle': '确认删除',
  'pages.knowledge.modal.deleteContent': '确定要删除这个资料库吗？关联的文件也会被删除。',
  'pages.knowledge.modal.add': '新增资料库',
  'pages.knowledge.modal.edit': '编辑资料库',
  'pages.knowledge.field.title': '资料库名称',
  'pages.knowledge.field.titleRequired': '请输入资料库名称',
  'pages.knowledge.field.titlePlaceholder': '请输入资料库名称',
  'pages.knowledge.field.indexName': '索引名称',
  'pages.knowledge.field.indexNameRequired': '请输入索引名称',
  'pages.knowledge.field.indexNamePlaceholder': '请输入索引名称（用于向量检索）',
  'pages.knowledge.field.description': '说明',
  'pages.knowledge.field.descriptionPlaceholder': '请输入资料库说明',
  'pages.knowledge.field.minScore': '相似度阈值',
  'pages.knowledge.field.minScoreTooltip': '召回结果的最低相似度分数，范围 0-1',
  'pages.knowledge.field.topN': '召回数量',
  'pages.knowledge.field.topNTooltip': '每次查询返回的最大文件数量',
  'pages.knowledge.upload.title': '添加文件',
  'pages.knowledge.upload.text': '拖拽文件到此或点击上传',
  'pages.knowledge.upload.hint': '支持 TXT、MD、PDF、DOCX、HTML、XLSX、CSV 等文档格式，单文件不超过 15MB',
  'pages.knowledge.rename.title': '重命名',
  'pages.knowledge.rename.placeholder': '请输入新名称',
  'pages.knowledge.createSuccess': '创建成功',
  'pages.knowledge.saveSuccess': '保存成功',
  'pages.knowledge.fillRequiredFields': '请填写必填项',
  'pages.knowledge.deleteSuccess': '删除成功',
  'pages.knowledge.renameSuccess': '重命名成功',
  'pages.knowledge.downloadFailed': '下载失败',
  'pages.knowledge.unsupportedFormat': '不支持的文件格式: {name}',
  'pages.knowledge.uploadSuccess': '{name} 上传成功',
  'pages.knowledge.uploadRecordFailed': '{name} 保存文件记录失败',
  'pages.knowledge.uploadFailed': '{name} 上传失败',
  'pages.knowledge.loadFailed': '加载资料库列表失败，请检查网络后重试。',
  'pages.knowledge.loadFailedToast': '刷新资料库列表失败，请稍后重试。',
  'pages.knowledge.filesLoadFailed': '加载文件列表失败，请稍后重试。',
  'pages.knowledge.filesLoadFailedToast': '刷新文件列表失败，请稍后重试。',
  'pages.knowledge.retry': '重试',

  'pages.login.googleBlocked': 'Google 登录组件加载中或被屏蔽，请检查网络',
  'pages.login.googleFailed': 'Google 登录失败，请重试！',
  'pages.login.googleProcessing': 'Google 登录处理中',
  'pages.login.googleLogin': 'Google登录',
  'pages.login.googleAuthProcessing': '正在处理 Google 授权，请稍候...',
  'pages.login.wechatComingSoon': '微信扫码登录暂未开启',
  'pages.login.googleAccessTokenMissing': '未获取到 Google 授权令牌',

  'pages.dashboard.accountData': '账户数据',
  'pages.dashboard.currentBalance': '当前点数余额',
  'pages.dashboard.totalSpent': '历史消耗点数',
  'pages.dashboard.requestCount': '请求次数',
  'pages.dashboard.threadCount': '工作次数',
  'pages.dashboard.inference': '推理',
  'pages.dashboard.image': '图片',
  'pages.dashboard.video': '视频',
  'pages.dashboard.audio': '音频',
  'pages.dashboard.credits': '点数',
  'pages.dashboard.images': '张',
  'pages.dashboard.seconds': '秒',
  'pages.dashboard.characters': '字符',
  'pages.dashboard.modelAnalysis': '模型数据分析',
  'pages.dashboard.last24Hours': '24小时',
  'pages.dashboard.last7Days': '7天',
  'pages.dashboard.consumptionDistribution': '消耗分布',
  'pages.dashboard.callCountDistribution': '调用次数分布',
  'pages.dashboard.noModelData': '暂无模型使用数据',
  'pages.dashboard.noModelDataHint': '开始使用 AI 模型后，数据将在此显示',
  'pages.resources.pageTitle': '资料资源',
  'pages.resources.pageSubtitle': '在统一工作区中浏览共享资料与系统资源。',
  'pages.resources.comingSoon': '资料库页面 - 即将上线',

  'editor.properties': '属性',
  'editor.properties.selectElement': '选择元素以编辑',
  'editor.properties.transform': '变换',
  'editor.properties.position': '位置',
  'editor.properties.scale': '缩放',
  'editor.properties.rotate': '旋转',
  'editor.properties.opacity': '不透明度',
  'editor.properties.blendMode': '混合模式',
  'editor.properties.text': '文字',
  'editor.properties.content': '内容',
  'editor.properties.fontSize': '字号',
  'editor.properties.fontFamily': '字体',
  'editor.properties.color': '颜色',
  'editor.properties.textAlign': '对齐',
  'editor.properties.fontWeight': '粗体',
  'editor.properties.fontStyle': '斜体',
  'editor.properties.textDecoration': '装饰',
  'editor.properties.letterSpacing': '字距',
  'editor.properties.lineHeight': '行高',
  'editor.properties.background': '背景',
  'editor.properties.cornerRadius': '圆角',
  'editor.properties.padding': '内距',
  'editor.properties.effects': '效果',
  'editor.properties.addEffect': '添加效果',
  'editor.properties.audio': '音频',
  'editor.properties.subtitle': '字幕',
  'editor.properties.subtitleY': '底部边距',
  'editor.properties.subtitleBg': '背景色',
  'editor.properties.volume': '音量',
  'editor.properties.muted': '静音',
  'editor.properties.playbackRate': '播放速率',
  'editor.properties.speed': '速度',
  'editor.properties.reverse': '倒播',
  'editor.properties.effectTrack': '效果轨道',
  'editor.properties.effectType': '效果类型',
  'editor.timeline': '时间线',
  'editor.timeline.importMedia': '导入素材开始编辑',
  'editor.timeline.track.mainTrack': '主轨道',
  'editor.timeline.track.text': '文字',
  'editor.timeline.track.audio': '音频',
  'editor.timeline.track.sticker': '贴纸',
  'editor.timeline.track.effect': '效果',
  'editor.timeline.track.subtitle': '字幕',
  'editor.timeline.split': '分割',
  'editor.timeline.duplicate': '复制片段',
  'editor.timeline.delete': '删除',
  'editor.timeline.detachAudio': '分离音轨',
  'editor.timeline.reverse': '倒播',
  'editor.timeline.rippleEdit': '涟漪编辑',
  'editor.timeline.undo': '撤销',
  'editor.timeline.redo': '重做',
  'editor.assets': '素材',
  'editor.assets.type.video': '视频',
  'editor.assets.type.image': '图片',
  'editor.assets.type.audio': '音频',
  'editor.assets.addText': '添加文字',
  'editor.assets.addSticker': '添加贴纸',
  'editor.assets.addEffect': '添加效果',
  'editor.assets.import': '导入素材文件',
  'editor.assets.importSubtitle': '导入字幕',
  'editor.assets.dragDrop': '拖放文件到此处',
  'editor.assets.delete.confirm.title': '确认删除',
  'editor.assets.delete.confirm.content': '确定要删除素材「{name}」吗？',
  'editor.assets.delete.inUse.title': '无法删除',
  'editor.assets.delete.inUse.content': '该素材正在被时间线上 {count} 个元素使用，请先移除相关元素。',
  'editor.preview': '预览',
  'editor.preview.play': '播放',
  'editor.preview.pause': '暂停',
  'editor.header.export': '导出',
  'editor.header.exporting': '导出中...',
  'editor.header.format': '格式',
  'editor.header.quality': '质量',
  'editor.header.saveToCloud': '保存到云端',
  'editor.export.title': '导出视频',
  'editor.export.cancel': '取消',
  'editor.export.renderingFrames': '正在渲染帧...',
  'editor.export.encodingVideo': '正在编码视频...',
  'editor.export.done': '完成',
  'editor.export.completed': '导出完成',
  'editor.export.cancelled': '导出已取消',
  'editor.export.failed': '导出失败',
  'editor.export.savedToCloud': '已导出并保存到云端',
  'editor.export.cloudUploadFailed': '已下载到本地，但云端上传失败',
  'editor.export.quality.low': '低',
  'editor.export.quality.medium': '中',
  'editor.export.quality.high': '高',
  'editor.export.quality.veryHigh': '超高',
  'editor.transition.select': '选择转场',
  'editor.transition.add': '添加转场',
  'editor.transition.remove': '移除转场',
  'editor.transition.duration': '转场时长',
  'editor.transition.fade': '淡入淡出',
  'editor.transition.fadeblack': '黑屏过渡',
  'editor.transition.fadewhite': '白屏过渡',
  'editor.transition.wipeleft': '从右向左擦除',
  'editor.transition.wiperight': '从左向右擦除',
  'editor.transition.wipeup': '从下向上擦除',
  'editor.transition.wipedown': '从上向下擦除',
  'editor.transition.slideleft': '向左滑动',
  'editor.transition.slideright': '向右滑动',
  'editor.transition.slideup': '向上滑动',
  'editor.transition.slidedown': '向下滑动',
  'editor.transition.circlecrop': '圆形裁切',
  'editor.transition.circleopen': '圆形展开',
  'editor.transition.circleclose': '圆形收缩',
  'editor.transition.dissolve': '溶解',
  'editor.transition.pixelize': '像素化',
  'editor.transition.radial': '径向擦除',
  'editor.transition.smoothleft': '平滑左推',
  'editor.transition.smoothright': '平滑右推',
  'editor.transition.smoothup': '平滑上推',
  'editor.transition.smoothdown': '平滑下推',
  'editor.transition.diagtl': '左上对角线',
  'editor.transition.diagtr': '右上对角线',
  'editor.transition.diagbl': '左下对角线',
  'editor.transition.diagbr': '右下对角线',
  'editor.transition.hlslice': '水平左百叶窗',
  'editor.transition.hrslice': '水平右百叶窗',
  'editor.transition.vuslice': '垂直上百叶窗',
  'editor.transition.vdslice': '垂直下百叶窗',
  'editor.transition.horzopen': '水平展开',
  'editor.transition.horzclose': '水平收缩',
  'editor.transition.vertopen': '垂直展开',
  'editor.transition.vertclose': '垂直收缩',
  'editor.transition.squeezeh': '水平挤压',
  'editor.transition.squeezev': '垂直挤压',
  'editor.transition.mode': '转场模式',
  'editor.transition.mode.overlap': '重叠',
  'editor.transition.mode.freeze': '冻结帧',
  'editor.properties.addKeyframe': '添加关键帧',
  'editor.properties.removeKeyframe': '删除关键帧',
  'editor.properties.fontGroup.system': '系统字体',
  'editor.properties.fontGroup.google': '谷歌字体',
  'editor.properties.colorPresets': '常用',
  'editor.preview.fullscreen': '全屏',
  'editor.preview.exitFullscreen': '退出全屏',
  'editor.properties.canvas': '画布',
  'editor.properties.canvasSize': '尺寸',
  'editor.properties.canvasWidth': '宽',
  'editor.properties.canvasHeight': '高',
  'editor.properties.canvasPreset': '预设',
  'editor.properties.canvasPreset.landscape': '16:9 横屏',
  'editor.properties.canvasPreset.portrait': '9:16 竖屏',
  'editor.properties.canvasPreset.square': '1:1 方形',
  'editor.properties.canvasPreset.fourThree': '4:3',
  'editor.properties.canvasPreset.custom': '自定义',
  'editor.properties.objectFit': '适配',
  'editor.properties.objectFit.cover': '填充',
  'editor.properties.objectFit.contain': '适应',
  'editor.properties.objectFit.fill': '拉伸',
  'editor.properties.objectFit.none': '原始',
  'editor.properties.elementsSelected': '个元素已选中',
  'editor.pageTitle': '视频编辑',
  'editor.pageTitleWithName': '视频编辑 - {name}',
};
